// Simple toast utility - console only, no alerts
const toast = {
  success: (message: string) => {
    console.log('✅', message);
  },
  error: (message: string) => {
    console.error('❌', message);
  },
  warning: (message: string) => {
    console.warn('⚠️', message);
  },
  info: (message: string) => {
    console.info('ℹ️', message);
  }
};

export default toast;
